import { DataSourceApi } from '@grafana/data';
import { DataQuery } from '@grafana/schema';
import { getQueryDisplayText } from 'app/core/utils/richHistory';

export const getQueryText = (query: DataQuery, datasource: DataSourceApi) => {
  return datasource?.getQueryDisplayText?.(query) || getQueryDisplayText(query);
};
